import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";


class PersonalDetails {
    private serviceName = '/personModel';

    async CreateUser(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/CreateUser`, data).catch((err) => {
            throw err.response;
        })
    }
    async edit(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/EditUser`, data).catch((err) => {
            throw err.response;
        })
    }

    async remove(id: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/Remove/${id}`).catch((err) => {
            throw err.response;
        })
    }

    async getAllPerson() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/getAllPerson`).catch((err) => {
            throw err.response;
        })
    }

    async getUser(id: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetUser/${id}`).catch((err) => {
            throw err.response;
        })
    }

    async getPersonsByRoleId(roleId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetPersonsByRoleId/${roleId}`).catch((err) => {
            throw err.response;
        })
    }

    async getAssigneeDetail(id: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetAssigneeDetail/${id}`).catch((err) => {
            throw err.response;
        })
    }

    async getAssigneeList() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetAssigneeDetail`).catch((err) => {
            throw err.response;
        })
    }

    async GetBase64ProfileImage(personId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetBase64ProfileImage?personId=${personId}`).catch((err) => {
            throw err.response;
        })
    }

    async GetPersonList(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetPersonList`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async DeleteProfileImage(personId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/DeleteProfileImage/${personId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async activate(mobile: string, id: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/Activate/${mobile}/${id}`).catch((err) => {
            throw err.response;
        })
    }

    async IsActiveUser() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/IsActiveUser`).catch((err) => {
            throw err.response;
        })
    }

}

export default new PersonalDetails();